import { inject, markRaw } from 'vue';
import { toast } from 'vue-sonner';
import { useQueryClient } from '@tanstack/vue-query';
import useWishlistToggleMutation from '../api/useWishlistToggleMutation';
import VNotificationBanner from '../../../../components/notifications/VNotificationBanner.vue';

export default function useWishlistToggle(isWished) {
  const trans = inject('translate');
  const queryClient = useQueryClient();

  const { mutate, isPending, isError } = useWishlistToggleMutation((_, { wished }) => {
    queryClient.invalidateQueries({ queryKey: ['wishlist'], exact: true });
    isWished.value = !wished;
    toast.custom(markRaw(VNotificationBanner), {
      componentProps: {
        message: isWished.value ? trans.get('miliboo.wishlist.success') : trans.get('miliboo.wishlist.removed'),
        level: 'info',
        duration: 4,
      },
      duration: 4 * 1000,
    });
  });

  const toggle = (productId) => mutate({ productId, wished: isWished.value });

  return {
    toggle,
    isPending,
    isError,
  };
}
